import { rem, rgba } from 'polished';
import styled from 'styled-components';

import { IUserType } from '../../';

export const StyledCloseButton = styled.button`
  position: absolute;
  top: ${rem('24px')};
  right: ${rem('24px')};
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${rem('24px')};
  height: ${rem('24px')};
  padding: 0;
  background-color: transparent;
  border: none;
  appearance: none;
  cursor: pointer;

  svg {
    display: block;
    width: ${rem('13px')};
    height: auto;
  }
`;

export const StyledPanel = styled.div`
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  border-top-right-radius: ${rem('24px')};
  border-top-left-radius: ${rem('24px')};
  transform: translateY(100%);
  transition: transform 0.25s ease;

  &:focus {
    outline: none; //TODO add proper focus style
  }
`;

export const StyledOverlay = styled.div<IUserType>`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: ${({ theme }) => theme.layers.modal};
  background-color: ${({ theme }) => `${rgba(theme.colors.cross.black, 0.5)}`};

  ${StyledCloseButton} {
    svg path {
      fill: ${({ theme, user }) =>
        user ? theme.colors.main : theme.colors.cross.black};
    }
  }

  ${StyledPanel} {
    background-color: ${({ theme, user }) =>
      user ? theme.colors[user].main : theme.colors.main};
  }

  &[class*='after-open'] {
    ${StyledPanel} {
      transform: translateY(0);
    }
  }
`;
